"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hash = void 0;
/* eslint-disable no-bitwise */
var POW_2_24 = Math.pow(2, 24);
var POW_2_32 = Math.pow(2, 32);
var hex = function (n) {
    var s = '';
    var v;
    for (var i = 7; i >= 0; --i) {
        v = (n >>> (i << 2)) & 0xF;
        s += v.toString(16);
    }
    return s;
};
var lrot = function (n, bits) {
    return ((n << bits) | (n >>> (32 - bits)));
};
var Uint32ArrayBigEndian = /** @class */ (function () {
    function Uint32ArrayBigEndian(length) {
        this.bytes = new Uint8Array(length << 2);
    }
    Uint32ArrayBigEndian.prototype.get = function (index) {
        index <<= 2;
        return (this.bytes[index] * POW_2_24)
            + ((this.bytes[index + 1] << 16)
                | (this.bytes[index + 2] << 8)
                | this.bytes[index + 3]);
    };
    Uint32ArrayBigEndian.prototype.set = function (index, value) {
        var high = Math.floor(value / POW_2_24);
        var rest = value - (high * POW_2_24);
        index <<= 2;
        this.bytes[index] = high;
        this.bytes[index + 1] = rest >> 16;
        this.bytes[index + 2] = (rest >> 8) & 0xFF;
        this.bytes[index + 3] = rest & 0xFF;
    };
    return Uint32ArrayBigEndian;
}());
var string2ArrayBuffer = function (s) {
    s = s.replace(/[\u0080-\u07ff]/g, function (c) {
        var code = c.charCodeAt(0);
        return String.fromCharCode(0xC0 | code >> 6, 0x80 | code & 0x3F);
    });
    s = s.replace(/[\u0080-\uffff]/g, function (c) {
        var code = c.charCodeAt(0);
        return String.fromCharCode(0xE0 | code >> 12, 0x80 | code >> 6 & 0x3F, 0x80 | code & 0x3F);
    });
    var n = s.length;
    var array = new Uint8Array(n);
    for (var i = 0; i < n; ++i) {
        array[i] = s.charCodeAt(i);
    }
    return array.buffer;
};
var hash = function (bufferOrString) {
    var source;
    if (bufferOrString instanceof ArrayBuffer) {
        source = bufferOrString;
    }
    else {
        source = string2ArrayBuffer(String(bufferOrString));
    }
    var h0 = 0x67452301;
    var h1 = 0xEFCDAB89;
    var h2 = 0x98BADCFE;
    var h3 = 0x10325476;
    var h4 = 0xC3D2E1F0;
    var i;
    var sbytes = source.byteLength;
    var sbits = sbytes << 3;
    var minbits = sbits + 65;
    var bits = Math.ceil(minbits / 512) << 9;
    var bytes = bits >>> 3;
    var slen = bytes >>> 2;
    var s = new Uint32ArrayBigEndian(slen);
    var s8 = s.bytes;
    var j;
    var w = new Uint32Array(80);
    var sourceArray = new Uint8Array(source);
    for (i = 0; i < sbytes; ++i) {
        s8[i] = sourceArray[i];
    }
    s8[sbytes] = 0x80;
    s.set(slen - 2, Math.floor(sbits / POW_2_32));
    s.set(slen - 1, sbits & 0xFFFFFFFF);
    for (i = 0; i < slen; i += 16) {
        for (j = 0; j < 16; ++j) {
            w[j] = s.get(i + j);
        }
        for (; j < 80; ++j) {
            w[j] = lrot(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
        }
        var a = h0;
        var b = h1;
        var c = h2;
        var d = h3;
        var e = h4;
        var f = void 0;
        var k = void 0;
        var temp = void 0;
        for (j = 0; j < 80; ++j) {
            if (j < 20) {
                f = (b & c) | ((~b) & d);
                k = 0x5A827999;
            }
            else if (j < 40) {
                f = b ^ c ^ d;
                k = 0x6ED9EBA1;
            }
            else if (j < 60) {
                f = (b & c) ^ (b & d) ^ (c & d);
                k = 0x8F1BBCDC;
            }
            else {
                f = b ^ c ^ d;
                k = 0xCA62C1D6;
            }
            temp = (lrot(a, 5) + f + e + k + w[j]) & 0xFFFFFFFF;
            e = d;
            d = c;
            c = lrot(b, 30);
            b = a;
            a = temp;
        }
        h0 = (h0 + a) & 0xFFFFFFFF;
        h1 = (h1 + b) & 0xFFFFFFFF;
        h2 = (h2 + c) & 0xFFFFFFFF;
        h3 = (h3 + d) & 0xFFFFFFFF;
        h4 = (h4 + e) & 0xFFFFFFFF;
    }
    return hex(h0) + hex(h1) + hex(h2) + hex(h3) + hex(h4);
};
exports.hash = hash;
